module.exports = __webpack_public_path__ + "img/Postmodernisme_Andre_kunstformer6.c77e13e0.jpg";